import type { ExtranetHotelFinance } from 'app/typings/core/extranet/hotel/finance';

export const normalizeTaxIdentifier = (value?: string) =>
  value?.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

const FRANCE_COUNTRY_NAME = 'France';
const FRANCE_COUNTRY_SLUG = 'FR';

const isFilled = (value?: string) => !!value?.trim();

const isFrenchBillingCountry = ({
  country,
  countrySlug,
}: ExtranetHotelFinance) =>
  country
    ? country === FRANCE_COUNTRY_NAME
    : countrySlug === FRANCE_COUNTRY_SLUG;

export const isBillingInformationComplete = (
  finance: ExtranetHotelFinance | undefined
) => {
  if (!finance) {
    return false;
  }

  const { companyName, street, zipCode, city, country, vat, siret } = finance;

  return (
    [companyName, street, zipCode, city, country, vat].every(isFilled) &&
    (!isFrenchBillingCountry(finance) || isFilled(siret))
  );
};
